// import './App.css';
import Home from './pages/home';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import './assets/css/universal.css';
import './assets/css/styles.css';
import ScrollToTop from './assets/jss/scrollTop';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { setLoader } from './pages/components/loader';

function App() {
  const dispatch = useDispatch();
  const {sliders} = useSelector((state) => state.sliders);
  

  
// useEffect(() => {
  setLoader();
// }, [])
  return (
    <BrowserRouter>
    <ScrollToTop />
      <Routes
      // onUpdate={() => window.scrollTo(0, 0)}
      >

        <Route path='/' element={<Home 
        sliders={sliders}
        />} />
        
      </Routes>
    </BrowserRouter>
  );
}

export default App;
